import Vue from "vue";
import Header from "./components/layout/Header.vue";
import Footer from "./components/layout/Footer.vue";
import Page from "./components/layout/Page.vue";
import Divider from "./components/layout/Divider.vue";
import Layout from "./components/layout/Layout.vue";
import Panel from "./components/layout/Panel.vue";

Vue.component("layout", Layout);
Vue.component("layout-header", Header);
Vue.component("layout-footer", Footer);
Vue.component("layout-page", Page);
Vue.component("panel", Panel);
Vue.component("divider", Divider);
